import React from 'react';
import Style from './circle.module.scss';
import Circle from './circle';
import Card, { CardTitle } from '../Card';
import { useNavigate } from 'react-router-dom';

interface EndpointOs {
  osName: string;
  osDisplayName: string;
  numberOfEndpoints: number;
  percentage: number;
  urlFilter: string;
  additionalInfo: Record<string, unknown>;
}

interface EndpointsByOsProps {
  endpointsByOs?: EndpointOs[]; // make it optional for safety
  groupId?: string | null;
}

const CircleComponent: React.FC<EndpointsByOsProps> = ({ endpointsByOs = [], groupId }) => {
  const navigate = useNavigate();
  const endpointsByOsData = Array.isArray(endpointsByOs) ? endpointsByOs : [];

  const circle0 = {
    data: endpointsByOsData[0]?.percentage || 0,
    devices: endpointsByOsData[0]?.numberOfEndpoints || 0,
    borderColor: 'linear-gradient(90deg, #D12929 0%, #8A1212 50%, #4A0404 100%)',
    img: '/images/windows.png',
    countColor: '#c72727',
    action: 'OS:windows',
    urlFilter: endpointsByOsData[0]?.urlFilter,
  };

  const circle1 = {
    data: endpointsByOsData[1]?.percentage || 0,
    devices: endpointsByOsData[1]?.numberOfEndpoints || 0,
    borderColor: '#828282',
    img: '/images/mac.png',
    countColor: '#828282',
    action: 'OS:mac',
    urlFilter: endpointsByOsData[1]?.urlFilter,
  };

  const circle2 = {
    data: endpointsByOsData[2]?.percentage || 0,
    devices: endpointsByOsData[2]?.numberOfEndpoints || 0,
    borderColor: 'linear-gradient(90deg, #1B9B39 0%, #093513 100%)',
    img: '/images/linux.png',
    countColor: '#1B9B39',
    action: 'OS:linux',
    urlFilter: endpointsByOsData[2]?.urlFilter,
  };

  const handleClick = (action: string, urlFilter?: string) => {
    const groupParam = groupId ? `&groupId=${groupId}` : '';
    navigate(`/DeviceManagement?action=${action}${groupParam}`);
  };

  return (
    <Card>
      <CardTitle title="Operating System Breakdown" />
      <div className={Style.circleContainer}>
        <Circle circleData={circle0} onClick={() => handleClick(circle0.action, circle0.action)} />
        <Circle circleData={circle1} onClick={() => handleClick(circle1.action, circle1.action)} />
        <Circle circleData={circle2} onClick={() => handleClick(circle2.action, circle2.action)} />
      </div>
    </Card>
  );
};

export default CircleComponent;
